import { useMemo } from 'react';
import { LiveDataBetsSectionProps } from './types';
import { formatLiveDataBets, splitNumber } from './utils';

export const useLiveDataPreparedFormattedBetsString = ({
  minBet,
  maxBet,
  isGameCardMinimised,
  currencySymbol
}: LiveDataBetsSectionProps) => {
  return useMemo(() => {
    const formattedMinBet = splitNumber(minBet);
    const formattedMaxBet = splitNumber(maxBet);

    const minMaxBetsStringRange = `${formattedMinBet} - ${formattedMaxBet}`;

    return isGameCardMinimised
      ? `${formatLiveDataBets(minMaxBetsStringRange)} ${currencySymbol}`
      : `${`${minMaxBetsStringRange} ${currencySymbol}`}`;
  }, [minBet, maxBet, isGameCardMinimised, currencySymbol]);
};
